import { render, staticRenderFns } from "./CreateSale.vue?vue&type=template&id=71d80e38&"
import script from "./CreateSale.vue?vue&type=script&lang=js&"
export * from "./CreateSale.vue?vue&type=script&lang=js&"
import style0 from "./CreateSale.vue?vue&type=style&index=0&id=71d80e38&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports